var render, staticRenderFns
import script from "./ProfilVersements.vue?vue&type=script&lang=js"
export * from "./ProfilVersements.vue?vue&type=script&lang=js"
import style0 from "./ProfilVersements.vue?vue&type=style&index=0&id=04528f50&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04528f50",
  null
  
)

export default component.exports